import { createSelector } from '@reduxjs/toolkit';

import { AppConfigService } from 'features/app-config/services';
import type { RootState } from 'features/app/store/store';
import { Mode } from 'features/multi-mode/enums';

export const deafSelector = ({ callDeaf }: RootState) => callDeaf;

export const isDeafConnectedSelector = ({ callDeaf }: RootState) =>
  callDeaf.status === 'connected';

export const isDeafConnectingSelector = ({ callDeaf }: RootState) =>
  callDeaf.status === 'connecting';

export const selectDeafConnectionWasNotAttempted = ({ callDeaf }: RootState) =>
  callDeaf.connectionAttempts === 0;

export const selectDeafHasConnected = ({ callDeaf }: RootState) =>
  callDeaf.hasConnected;

export const isDeafReconnectSelector = createSelector(
  isDeafConnectedSelector,
  isDeafConnectingSelector,
  selectDeafConnectionWasNotAttempted,
  (isDeafConnected, isDeafConnecting, isConnectionWasNotAttempted) =>
    !isDeafConnected && !isDeafConnecting && !isConnectionWasNotAttempted
);

export const isDeafUnavailableSelector = ({ callDeaf }: RootState) =>
  callDeaf.status === 'unavailable';

export const isDeafDisconnectedSelector = ({ callDeaf }: RootState) =>
  callDeaf.status === 'disconnected';

export const deafStatusSelector = ({ callDeaf }: RootState) => callDeaf.status;

export const deafIsLoadingSelector = ({ callDeaf }: RootState) =>
  callDeaf.isLoading;

export const deafNameSelector = ({ callDeaf }: RootState) => callDeaf.name;

export const isDeafMutedSelector = ({ callDeaf }: RootState) =>
  callDeaf.isMuted;

export const deafPhoneNumberSelector = ({ callDeaf }: RootState) =>
  callDeaf.phoneNumber;

// VRI stores an IP as phoneNumber, so it always uses the default outbound CID.
// VRS prefers the deaf phone as hearing outbound caller ID; if it is not set
// yet (common on H2D before deaf is dialed/spawned), fall back to the default.
export const deafPhoneNumberByModeSelector = ({
  callDeaf,
  multiMode,
}: RootState) => {
  if (multiMode.mode !== Mode.VRS) {
    return AppConfigService.defaultOutboundCallerIdEnglish;
  }

  return (
    callDeaf.phoneNumber || AppConfigService.defaultOutboundCallerIdEnglish
  );
};

export const selectIsDeafUserFromSorenson = ({ callDeaf }: RootState) =>
  callDeaf.isSorenson;
